import React, { useState, useEffect } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import {
    /* blueberryTwilightPalette,
    mangoFusionPalette, */
    cheerfulFiestaPalette,
  } from '@mui/x-charts/colorPalettes';

function SpedizioniDelGiorno({
    data,
    titolo,
    displayTitolo,
    key
}) {
    

    const [refresh,setRefresh] = useState(false)

    useEffect(() => {
        setRefresh(true);
    }, [key]);

    if (data) {
        return (
            <div>
                {titolo && displayTitolo && <div className="tc sfondoColChiaro pa2 b">{titolo}</div>}
            <div className="pa2 flex flex-wrap items-center">
            <div className="w-100 pl4 pt2 pb3 bordoColAlt bb">
                    <div>Tot spedizioni: <strong>{data.tot[0].totSpedizioni + " ordini"}</strong></div>
                    <div>Tot colli: <strong>{data.tot[0].totColli + " colli"}</strong></div>
                    <div>Tot BRT: <strong>{data.brt[0].sped + " ordini"}</strong></div>
                    <div>Tot DHL: <strong>{data.dhl[0].sped + " ordini"}</strong></div>
                    <div>Tot UPS: <strong>{data.ups[0].sped + " ordini"}</strong></div>
                    <div>Importo totale: <strong>{data.tot[0].totImporto && data.tot[0].totImporto.replace('.', ',').replace(/\d(?=(?:(?:\d{3})+),)/g, match => `${match}.`) + " €"}</strong></div>
                </div>
                <div className="w-100 pt2 pb2">
                    <div className="tc b">Ordini/colli</div>
                    <PieChart
                        series={[
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `${item.label} - 
                                        ${item.value}`
                                        )
                                },
                                data: [
                                    { value: data.brt[0].sped, label: 'BRT', color: '#ff4136' },
                                    { value: data.dhl[0].sped, label: 'DHL', color: '#ffb700' },
                                    { value: data.ups[0].sped, label: 'UPS', color: '#5c3419' },
                                    { value: data.altriCorrieri[0].sped, label: 'ALTRI', color: '#00449e' },
                                ],
                                innerRadius: 0,
                                outerRadius: 70,
                                cx: 140,
                                cy: 120,
                            },
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `
                                        ${item.value} c.`
                                        )
                                },
                                data: [
                                    { value: data.brt[0].colli, label: 'BRT', color: '#ff4136' },
                                    { value: data.dhl[0].colli, label: 'DHL', color: '#ffb700' },
                                    { value: data.ups[0].colli, label: 'UPS', color: '#5c3419' },
                                    { value: data.altriCorrieri[0].colli, label: 'ALTRI', color: '#00449e' },
                                ],
                                innerRadius: 80,
                                outerRadius: 110,
                                cx: 140,
                                cy: 120,
                            },
                        ]}

                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'white',
                                fontWeight: 'bold',
                            },
                            
                        }}
                        width={300}
                        height={240}
                        legend={{ hidden: true }}
                    />

                </div>
                <div className="w-100 pt2 pb2">
                    <div className="tc b">Tipi ordine</div>
                    <PieChart
                        series={[
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let text;
                                        switch (item.label) {
                                            case "Ordine Web":
                                                text = "W"
                                                break;
                                                case "Invio per sostituzione":
                                                    text = "Sost"
                                                    break;
                                                    case "Nuova spedizione":
                                                text = "N.S."
                                                break;
                                            default: text = ""
                                                break;
                                        }
                                        return (
                                            `${text}`
                                        )
                                    }
                                },
                                data: data.tipiOrdine,
                                innerRadius: 40,
                                outerRadius: 110,
                                cx: 140,
                                cy: 120,
                            }
                        ]}

                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        legend={{ hidden: true }}
                    />

                </div>
                <div className="w-100 pt2 pb2">
                    <div className="tc b">Ordini/Corrispettivi</div>
                    <PieChart
                        series={[
                            
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `
                                        ${item.value}`
                                        )
                                },
                                data: data.resultsRicercaOrdiniNazione,
                                innerRadius: 80,
                                outerRadius: 110,
                                cx: 140,
                                cy: 120,
                            },
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let emoji;
                                        switch (item.label) {
                                            case "Italia":
                                                emoji = "IT"
                                                break;
                                                case "Francia":
                                                    emoji = "FR"
                                                    break;
                                                    case "Germania":
                                                    emoji = "DE"
                                                    break;
                                                    case "Spagna":
                                                    emoji = "ES"
                                                    break;
                                            default: emoji = ""
                                                break;
                                        }
                                        return (
                                            `${emoji}`
                                        )}
                                },
                                data: data.resultsRicercaCorrispettivi,
                                innerRadius: 0,
                                outerRadius: 70,
                                cx: 140,
                                cy: 120,
                            },
                        ]}
                        colors={cheerfulFiestaPalette} // oppure cheerfulFiestaPalette oppure mangoFusionPalette
                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        legend={{ hidden: true }}
                    />

                </div>
                
            </div>
            </div>
        )
    } else {
        return (<div>no data</div>)
    }

}

export default SpedizioniDelGiorno;